import React from "react";
import { getInitialsOfUserName, formatAmountInLocale } from "../../utils/global";

const LiveActivities = ({ id, screenName, order_type, currentOrderData, poolProgressBarPercent, noOfSplitPaymentsDone, noOfPax, shopDetails, amountPaidSoFar, amountLeft, getListActivitiesResult, this_orderIsRefundedBool }) => {
  return (
    <div className="live-activities-container">
      <div className="card-outer">
        <p className="note orderIdArea">
          <span className="orderIdArea_inner">
            ID:
            {' '}
            <span id="order-id">{id}</span>
          </span>
        </p>

        <div className="card-inner">
          {screenName !== "pool_completed" &&
            <div className="progress-container">
              {order_type === 'variable_self' && 
                <div className="row justify-content-between">
                  <div className="col-6">
                    <label className="form-label">Stack progress</label>
                  </div>
                  <div className="col-6 text-end">
                    {/* <label className="form-label">{shopDetails.currency_with_symbol}{formatAmountInLocale(shopDetails.user_currency,amountPaidSoFar)} stacked — {shopDetails.currency_with_symbol}{formatAmountInLocale(shopDetails.user_currency,amountLeft)} to go</label> */}
                    <label className="form-label">{shopDetails.currency_with_symbol}{amountPaidSoFar} / {formatAmountInLocale(shopDetails.user_currency,currentOrderData.total_amount)}</label>
                  </div>
                </div>
              }
              {(order_type === 'fixed_price' || currentOrderData === 'undefined') && 
                <div className="row justify-content-between">
                  <div className="col-6">
                    <label className="form-label">Split progress</label>
                  </div>
                  <div className="col-6 text-end">
                    <label className="form-label">{noOfSplitPaymentsDone} / {noOfPax} splits done</label>
                  </div>
                </div>
              }
              {order_type === 'fixed_payforme' && 
                <div className="row justify-content-between">
                  <div className="col-6">
                    <label className="form-label">Status</label>
                  </div>
                  <div className="col-6 text-end">
                    <label className="form-label">Waiting for payment</label>
                  </div>
                </div>
              }
              {order_type === 'variable_price' && 
                <div className="row justify-content-between">
                  <div className="col-6">
                    <label className="form-label">Share progress</label>
                  </div>
                  <div className="col-6 text-end">
                    <label className="form-label">{shopDetails.currency_with_symbol}{amountPaidSoFar} / {formatAmountInLocale(shopDetails.user_currency,currentOrderData.total_amount)}</label>
                  </div>
                </div>
              }
              {order_type === 'fixed_cart' && 
                <div className="row justify-content-between">
                  <div className="col-6">
                    <label className="form-label">Checkout progress</label>
                  </div>
                  <div className="col-6 text-end">
                    <label className="form-label">{shopDetails.currency_with_symbol}{amountPaidSoFar} / {formatAmountInLocale(shopDetails.user_currency,currentOrderData.total_amount)}</label>
                  </div>
                </div>
              }

              <div className="progressBar">
                <div
                  className="progress-fill"
                  style={{ width: `${poolProgressBarPercent}%` }}
                ></div>
              </div>

              <div className="mt-1 text-center">
                <p className="form-label">
                  Total amount:
                  {' '}
                  <span>{shopDetails.currency_with_symbol}{formatAmountInLocale(shopDetails.user_currency,currentOrderData.total_amount)}</span>
                </p>
              </div>
            </div>
          }
          {screenName === "pool_completed" && this_orderIsRefundedBool === false &&
            <div className="progress-container">
              {order_type === 'variable_self' && 
                <label className="form-label">Stack completed</label>
              }
              {(order_type === 'fixed_price' || currentOrderData === 'undefined') && 
                <label className="form-label">All paid up</label>
              }
              {order_type === 'fixed_payforme' && 
                <label className="form-label">Payment completed</label>
              }
              {order_type === 'variable_price' && 
                <label className="form-label">Share completed</label>
              }
              {order_type === 'fixed_cart' && 
                <label className="form-label">checkout completed</label>
              }

              <div className="progressBar">
                <div
                  className="progress-fill"
                  style={{ width: `${poolProgressBarPercent}%` }}
                ></div>
              </div>
            </div>
          }

          {getListActivitiesResult.length > 0 &&
            <div className="live-messages-container">
              {getListActivitiesResult.map((singleActivity, index) => (
                <div
                  key={index}
                  className="d-flex align-items-center mb-3 single-activity-tr"
                >
                  <div className="userProfilePictureContainer me-3">
                    <div className="initialsContainer">
                      {getInitialsOfUserName(singleActivity.user_name)}
                    </div>
                  </div>
                  <div className="flex-grow-1">
                    <div className="d-flex justify-content-between align-items-center">
                      <h6 className="mb-0">
                        <strong>{singleActivity.user_name}</strong>
                      </h6>
                    </div>
                    <p>
                      <span style={{ verticalAlign: "middle" }}>{singleActivity.message}</span>
                    </p>
                    {singleActivity.order_status === 'authorized' && typeof singleActivity.items_status !== 'undefined' &&
                      <>
                        {singleActivity.items_status.event_list.length > 0 &&
                          <p className="note">Has paid for: {singleActivity.items_status.event_list.map(item => item.name).join(", ")}</p>
                        }
                      </>
                    }
                  </div>
                </div>
              ))}
            </div>
          }
        </div>
      </div>
    </div>
  );
};

export default LiveActivities;
